import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dispatch-modal',
  templateUrl: './dispatch-modal.component.html',
  styleUrls: ['./dispatch-modal.component.scss']
})
export class DispatchModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  submit(): void {
    alert('submitted');
  }

}
